module.exports = __webpack_public_path__ + "static/img/book24.5298098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book24.jpg
// module id = 65sU
// module chunks = 1